import {DatePipe } from '@angular/common';

export enum usertype {
    undefined = 0,
    student,
    admin,
    instructor,
    superadmin
  }

export class Mhsrcuser {

  public constructor(init?: Partial<Mhsrcuser>) {
    Object.assign(this, init);
   }
    id: string;
    firstName: string;
    middleName: string;
    lastName: string;
    email: string;
    roleId: number;
    password: string;
    guidId: string;
    createdBy: string;
    createdOn: string;
    modifiedBy: string;
    modifiedOn: DatePipe;
    deletedOn: DatePipe;
    deletedBy: string;
    accessFailedCount: number;
    concurrencyStamp: string;
    emailConfirmed: boolean;
    lockoutEnabled: boolean;
    lockoutend?: any;
    norormalizedEmail: string;
    passwordHash: string;
    phoneNumber: string;
    phoneNumberConfirmed: string;
    securityStamp: string;
    twoFactorEnabled: boolean;
    userName: string;
    discriminator: string;
    verificationCode: string;
    token: Mhsrcuser;
    // userRoles: [] : null;
}

export class User {constructor(
  public name: string,
  public email: string
) {}
}

export class LoginReq {
  constructor() {
    this.email = '';
    this.password = '';
  }
  public email: string;
  public password: string;
}

export class UserProfile {constructor(
  public id: number,
  public firstName: string,
  public middleName: string,
  public lastName: string,
  public email: string,
  public roleId: number,
  public password: string,
  public guidId: string
) {}
}




// WEBPACK FOOTER //
// ./src/app/models/user.ts